import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { fetchJournal } from "../redux/actions/journalAction";
import { useAppDispatch } from "../redux/hook";
import { FiHexagon } from "../assets/icons/vander";

import economic from "../assets/images/icons/decent-work-and-economic-growth.svg";

export default function Journals() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [journalData, setJournalData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadJournal = async () => {
      const journal = await dispatch(fetchJournal());
      if (
        typeof journal.payload === "string" ||
        journal.payload === undefined
      ) {
        setLoading(false);
        // navigate(checkError(homeEdit.payload));
      } else {
        setLoading(false);
        setJournalData(journal.payload);
      }
    };
    loadJournal();
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative md:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-6 md:text-2xl text-xl font-medium">
            {t("external.journal.our_journals")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.journal.click_to_download")}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
          {journalData.map((item, index) => {
            return (
              <div
                className="group relative lg:px-6 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center"
                key={index}
              >
                <div className="relative overflow-hidden text-transparent -m-3">
                  <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                  <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                    <img src={economic} className="h-8" alt="" />
                  </div>
                </div>

                <div className="mt-6">
                  {item.month}-{item.year}
                  <p className="text-slate-400 dark:text-white/60 text-[15px] duration-500 mt-3">
                    <a
                      href={
                        process.env.REACT_APP_API_URL +
                        "/wwwroot/images/" +
                        item.image_file
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
